import { useContext, useEffect, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { GlobalFunctionsContext } from "../services/GlobalFunctionsContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import "./Microsites.scss"
import useWindowSize from "../hooks/useWindowSize";

export default function Microsites({items, speed = 300000}) {
  const { convertStringToLink } = useContext(GlobalFunctionsContext);
  const navigate = useNavigate();
  const [slidesPerView, setSlidesPerView ] = useState(3)
  const { width } = useWindowSize();
  
  const visitMicro = (item,brandName) => {
    navigate('/marca/'+item.id+'-'+brandName)
  }

  useEffect(() => {
    setSlidesPerView(width >= 720 ? 3 : 1)
  }, [width])

  // Igual que en Carousel.js: Swiper tira warning (y el loop no anda bien)
  // si no hay bastantes más slides que slidesPerView.
  const canLoop = items.length > slidesPerView * 2;

  return (
    <>
    { items.length > 0
        ? <div className="ms content">
            <div className="ms-header">
              <div className="ms-title">Micrositios por marca</div>
              <div className="ms-subtitle">Trabajamos con las mejores marcas del mercado. Siempre disponemos de stock y al mejor precio.</div>
            </div>
            <>
              <div className="ms-wrapper">
                <Swiper
                  slidesPerView={slidesPerView}
                  spaceBetween={10}
                  loop={canLoop}
                  rewind={!canLoop}
                  navigation={true}
                  modules={[Autoplay, Navigation]}
                  className="ms-container"
                >
                  {items.map((item, i) => {
                    const brandName = convertStringToLink(item.nombre)
                    return (
                      <SwiperSlide className="ms-container-items">
                          <div className="ms-background">
                            <img src={item.bannerUrl+`_medium.webp`} alt={`imgBanner-${i}`} />
                          </div>
                          <div className="ms-logo" onClick={()=>{visitMicro(item,brandName)}}>
                            <img src={item.logoUrl} alt={`imgLogo-${i}`} />
                          </div>
                          <div className="ms-items">
                            {item.products.map((prod) => {
                              let prodName = convertStringToLink(prod.nombre)
                              return (<Link className="ms-item" to={`producto/${prod.id}-${prodName}`}>
                                <img src={prod.imgUrl} />
                              </Link>)
                              }
                            )}
                          </div>
                          <div className="ms-action btn-content">
                            <Link className="btn btn-dark small" to={`/marca/${item.id}-${brandName}`}>Visitar micrositio <ArrowRightIcon /></Link>
                          </div>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </div>
            </>
          </div>
        :null
    }
    </>
  )
}